import { Loader2 } from 'lucide-react';

/**
 * ETAPA VISUAL 7 — ESTADOS VAZIO E CARREGANDO
 *
 * Medição que motivou estes dois componentes:
 *
 *   estado vazio  ->  3 paddings diferentes (`py-16` 46x, `py-12` 10x, `py-8`
 *                     15x) e 4 tamanhos de ícone (32, 36, 40, 64);
 *   carregando    ->  `Carregando...` escrito 42x à mão, cada um com o seu
 *                     tamanho de spinner e a sua altura de caixa.
 *
 * Nada disso é defeito isolado — é a soma que dá a sensação de "sistema em
 * evolução". Aqui os dois viram um desenho só.
 */

/**
 * Caixa de carregamento. Mantém o `role="status"` + `aria-live` que a Etapa 2
 * espalhou à mão, para o leitor de tela anunciar o carregamento.
 *
 * `altura` existe porque as telas usam duas medidas: `h-64` dentro de cartão e
 * `h-[60vh]` quando a tela inteira está carregando.
 */
export function EstadoCarregando({ texto = 'Carregando...', altura = 'h-64', className = '' }) {
  return (
    <div
      className={`flex items-center justify-center ${altura} ${className}`}
      data-testid="estado-carregando"
    >
      <Loader2 className="h-8 w-8 animate-spin text-[#D4AF37]" aria-hidden="true" />
      <span role="status" aria-live="polite" className="ml-2 text-sm text-[#A1A1AA]">
        {texto}
      </span>
    </div>
  );
}

/**
 * Estado vazio: ícone de ilustração + título + explicação + ação opcional.
 *
 * `compacto` é para quando o vazio acontece DENTRO de uma lista/cartão pequeno
 * (o caso dos `py-8`), e não ocupando a área toda.
 *
 * O ícone é 40px por padrão: na escala de ícones do sistema, 32+ é
 * ILUSTRAÇÃO — não compete com os ícones funcionais de 12/16/20.
 */
export function EstadoVazio({
  icone: Icone,
  titulo,
  descricao,
  acao,
  compacto = false,
  className = '',
  testid = 'estado-vazio',
}) {
  const tamanhoIcone = compacto ? 'h-8 w-8' : 'h-10 w-10';

  return (
    <div
      className={`flex flex-col items-center justify-center text-center ${
        compacto ? 'py-8' : 'py-12'
      } ${className}`}
      data-testid={testid}
    >
      {Icone && <Icone className={`${tamanhoIcone} mb-3 text-[#71717A]`} aria-hidden="true" />}

      {titulo && (
        <h3 className={`font-bold text-white ${compacto ? 'text-base' : 'text-lg'}`}>{titulo}</h3>
      )}

      {descricao && (
        <p className={`mt-1 text-sm text-[#A1A1AA] ${acao ? 'mb-4' : ''}`}>{descricao}</p>
      )}

      {acao}
    </div>
  );
}
